import { updateTargetSystem } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useUpdateTargetSystem = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (TargetSystemNewData) => updateTargetSystem(TargetSystemNewData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetTargetSystem"]);
        toast.fire(
          "Success",
          "Policy Management System Updated Successfully",
          "success"
        );
      },
      onError: () => {
        toast.fire(
          "Failed",
          "Failed to Update Policy Management System!",
          "",
          "error"
        );
      },
    }
  );
  return mutate;
};
export default useUpdateTargetSystem;
